// extracted by mini-css-extract-plugin
export var notificationHost = "_mk-0";